var _g, _rect, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_128_8335)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 55,
    height: 55,
    rx: 18,
    fill: "#F1B31B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_128_8335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 15,
    width: 55,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 55,
    height: 55,
    rx: 18,
    fill: "#F1B31B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_128_8335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7529 28.751C58.4221 29.2354 60.0893 29.7239 61.7595 30.2032C65.6821 31.3295 69.6078 32.4497 73.5305 33.5739C74.3833 33.8181 74.6527 34.2642 74.5296 35.1048C74.4842 35.4146 74.6285 35.7244 74.6275 36.0484C74.6174 39.9953 74.6255 43.9422 74.6134 47.8891C74.6124 48.2009 74.7032 48.3452 74.9878 48.4865C76.3239 49.1496 76.9819 50.2677 77.0324 51.7421C77.0586 52.5061 77.0485 53.272 77.0344 54.037C77.0203 54.8433 76.5197 55.3267 75.7093 55.3298C74.1794 55.3348 72.6485 55.3348 71.1186 55.3298C70.2749 55.3277 69.7956 54.8534 69.7905 54.0108C69.7855 53.1782 69.7612 52.3446 69.8077 51.5141C69.8864 50.1103 70.5938 49.093 71.8492 48.4734C72.1086 48.3452 72.2156 48.2191 72.2146 47.9123C72.2014 44.2076 72.2055 40.5019 72.2055 36.7972C72.2055 36.6771 72.2055 36.557 72.2055 36.3955C71.1014 36.7094 70.0226 37.0152 68.9448 37.322C68.52 37.4431 68.1001 37.5844 67.6702 37.6812C67.4189 37.7378 67.3644 37.8589 67.3675 38.096C67.3745 38.7792 67.4189 39.4655 67.2373 40.1376C66.9557 41.178 66.3512 41.9672 65.3794 42.4385C62.9614 43.6122 60.3971 44.2318 57.7187 44.3761C54.6104 44.5437 51.595 44.1037 48.7027 42.927C47.8096 42.5636 46.9104 42.2034 46.321 41.3637C45.8064 40.6321 45.6045 39.8227 45.6207 38.9387C45.6277 38.5552 45.7841 38.0738 45.5541 37.8134C45.3431 37.5743 44.8719 37.5591 44.5116 37.4562C42.8 36.9667 41.0874 36.4823 39.3769 35.9929C38.8783 35.8506 38.512 35.5579 38.406 35.0281C38.3152 34.572 38.4555 34.1784 38.8117 33.8726C38.9984 33.7131 39.2255 33.6364 39.4596 33.5698C44.9798 31.9925 50.499 30.4131 56.0182 28.8348C56.0808 28.8166 56.1525 28.8196 56.1898 28.75C56.3765 28.751 56.5652 28.751 56.7529 28.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1643 69.9903C44.6676 69.9903 42.1709 69.9913 39.6742 69.9903C38.6771 69.9903 38.2159 69.4716 38.2522 68.4796C38.3471 65.8698 39.0808 63.467 40.5834 61.3245C42.6997 58.307 45.592 56.4744 49.2059 55.7629C49.4743 55.7104 49.5328 55.8749 49.6317 56.0233C51.3403 58.5886 53.0367 61.162 54.7604 63.7173C55.044 64.1381 55.1762 64.5458 55.1661 65.0534C55.1378 66.5702 55.1469 68.087 55.1631 69.6038C55.1661 69.9106 55.0975 70.0014 54.7755 69.9994C52.2385 69.9833 49.7014 69.9903 47.1643 69.9903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.575 69.9925C63.0379 69.9925 60.5008 69.9875 57.9637 69.9996C57.6569 70.0006 57.56 69.936 57.5641 69.6101C57.5823 67.9591 57.5752 66.308 57.5691 64.657C57.5681 64.4461 57.6186 64.2725 57.7356 64.0969C59.5189 61.4196 61.3011 58.7422 63.0681 56.0558C63.2377 55.7974 63.3941 55.747 63.6827 55.8116C68.8861 56.9751 72.3344 60.0784 73.9744 65.1535C74.3467 66.305 74.49 67.509 74.485 68.725C74.481 69.496 73.9855 69.9905 73.1862 69.9915C70.6491 69.9956 68.112 69.9925 65.575 69.9925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5713 44.248C51.5083 47.8316 60.7897 48.0365 67.1576 44.2682C67.091 45.5115 66.8408 46.6963 66.4209 47.8448C65.4572 50.4767 63.8495 52.6131 61.4094 54.024C58.5927 55.6518 55.6621 55.9979 52.5992 54.6436C48.7896 52.9583 46.7056 49.9499 45.8044 45.998C45.6752 45.4348 45.6238 44.8596 45.5713 44.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3712 61.7755C55.4326 60.3667 54.5163 58.9932 53.5283 57.5117C55.4458 58.0153 57.2593 58.0405 59.1212 57.6268C58.2139 58.9952 57.3057 60.3657 56.3712 61.7755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8277 65.1546C64.4261 65.1546 64.0244 65.1647 63.6228 65.1526C62.9416 65.1314 62.4168 64.6076 62.4097 63.9577C62.4027 63.3128 62.9285 62.7608 63.6036 62.7457C64.42 62.7285 65.2375 62.7275 66.0529 62.7457C66.7411 62.7608 67.2377 63.2896 67.2336 63.9587C67.2296 64.6248 66.726 65.1314 66.0317 65.1526C65.631 65.1647 65.2294 65.1546 64.8277 65.1546Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_128_8335",
    x: 0,
    y: 0,
    width: 115,
    height: 115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.701961 0 0 0 0 0.105882 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_128_8335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_128_8335",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.812a0e8b432ff9f7df6094b0f0fc247b.svg";
export { ForwardRef as ReactComponent };